class KokoAnchoredSearch {
  constructor() {
    this.sharedSearch = document.querySelector('#KokoAnchoredSearch');
    this.input = this.sharedSearch?.querySelector('input[type="search"]');
    this.form = this.input?.closest('form');
    this.featured = this.sharedSearch?.querySelector('[data-koko-search-featured]');
    this.featuredLinks = this.sharedSearch?.querySelectorAll('[data-koko-search-featured-link]') || [];
    this.summaryToggle = this.sharedSearch?.querySelector('summary');
    this.detailsContainer = this.sharedSearch?.querySelector('details');
    this.overlay = this.sharedSearch?.querySelector('.modal-overlay');
    if (!this.sharedSearch || !this.input || !this.summaryToggle || !this.detailsContainer) return;

    this.summaryToggle.setAttribute('aria-expanded', 'false');
    this.detailsContainer.addEventListener('toggle', () => {
      this.summaryToggle.setAttribute('aria-expanded', String(this.detailsContainer.open));
      if (this.detailsContainer.open) this.publish('kokodress:search_featured_opened');
    });
    this.overlay?.addEventListener('click', () => requestAnimationFrame(() => this.summaryToggle.focus()));
    this.input.addEventListener('input', () => this.syncFeaturedState());
    this.form?.addEventListener('reset', () => requestAnimationFrame(() => this.syncFeaturedState()));
    this.featuredLinks.forEach((link) =>
      link.addEventListener('click', () =>
        this.publish('kokodress:search_featured_clicked', {
          collection_key: link.dataset.kokoSearchFeaturedKey,
          collection_title: link.querySelector('.koko-search-featured__name')?.textContent?.trim(),
          destination: link.getAttribute('href'),
        })
      )
    );
    this.sharedSearch.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') this.summaryToggle.focus();
    });
    this.syncFeaturedState();
  }

  syncFeaturedState() {
    if (this.featured) this.featured.hidden = this.input.value.trim().length > 0;
  }

  publish(eventName, data = {}) {
    const payload = {
      ...data,
      placement: 'header_search',
      viewport: window.innerWidth >= 1280 ? 'desktop' : 'drawer',
    };

    try {
      const publication = window.Shopify?.analytics?.publish?.(eventName, payload);
      publication?.catch?.(() => {});
    } catch {
      // Analytics must never block search or collection navigation.
    }
  }
}

document.addEventListener('DOMContentLoaded', () => new KokoAnchoredSearch());
